import {
  actions,
  getLibraryCountAsync,
  getMyStartedContentAsync,
  getMyCompletedContentAsync,
  getMyFollowedContentAsync,
  getMyBookmarkedContainerAsync,
  getMyHighlightedContainerAsync,
} from './slices';

export const MylibraryActions = {
  ...actions,

  getLibraryCountAsync,
  getMyStartedContentAsync,
  getMyCompletedContentAsync,
  getMyFollowedContentAsync,
  getMyBookmarkedContainerAsync,
  getMyHighlightedContainerAsync,
};
